import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ClientProcessingService } from '@services/client-processing.service';

/**
 * Le back renvoie 423 (message `errors.client_processing`) sur toute mutation refusée
 * pendant une synchro. On ré-affiche l'overlay bloquant + toast traduit, même si
 * l'utilisateur a retiré le div du DOM.
 *
 * ClientProcessingService dépend (transitivement) de HttpClient : on le résout
 * paresseusement via l'Injector pour éviter une dépendance circulaire.
 */
export const clientProcessingInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        error.status === 423 ||
        error.error?.message === 'errors.client_processing'
      ) {
        injector.get(ClientProcessingService).notifyLocked();
      }
      return throwError(() => error);
    })
  );
};
